import { formatToMoney } from "../../../../lib/formatter"
import { hyphenSymbol, textTime, timeDurationDropdown } from "../VariableStatic";

export class ConferenceProjectPresenter {
  constructor(conferenceProject) {
    const person = 'ท่าน';

    let limitPeople = hyphenSymbol
    if (conferenceProject.limit) {
      if (
        conferenceProject.limit.from
        && conferenceProject.limit.to
      ) {
        limitPeople = `${conferenceProject.limit.from} - ${conferenceProject.limit.to}`
      } else if (conferenceProject.limit.from) {
        limitPeople = conferenceProject.limit.from
      }
    }

    const pricePackPerUnitText = formatToMoney(
      conferenceProject.price_package_per_unit
    ) || ''

    const pricePackagePerUnitText = `${formatToMoney(
      conferenceProject.price_package_per_unit, 2, '฿'
    )}/${person}`

    const breakPackages = conferenceProject.break_packages.map((breakPackage, breakIndex) => {
      const lunch = breakPackage.number_of_lunch_break
        && breakPackage.number_of_lunch_break >= 1
        ? `12:00${textTime}`
        : null;

      const breaksByNumberOfBreak = breakPackage.number_of_coffee_break
        && breakPackage.number_of_coffee_break > 0
        ? Array.from(
          { length: breakPackage.number_of_coffee_break }
        ).fill({})
        : null

      const breaks = breaksByNumberOfBreak
        ? breaksByNumberOfBreak.map((_, index) => ({
            id: index + 1,
            time: null
          }))
        : null

      const priceOptions = breakPackage.price_options
        && breakPackage.price_options.length > 0
        ? breakPackage.price_options.map((priceOption) => {
          let durationAttendeeTitle
          if (priceOption.from_attendee_count && priceOption.to_attendee_count) {
            durationAttendeeTitle = `${priceOption.from_attendee_count} - ${priceOption.to_attendee_count}`;
          } else if (priceOption.from_attendee_count) {
            durationAttendeeTitle = `${priceOption.from_attendee_count} >=`
          } else if (priceOption.to_attendee_count) {
            durationAttendeeTitle = `<= ${priceOption.to_attendee_count}`
          }

          return {
            fromAttendeeCount: priceOption.from_attendee_count,
            toAttendeeCount: priceOption.to_attendee_count,
            pricePerPerson: formatToMoney(priceOption.price_per_person),
            durationAttendeeTitle
          }
        })
        : null

      return {
        id: breakIndex + 1,
        title: breakPackage.title,
        breaks,
        lunch,
        priceOptions,
        isSelect: false,
        typePackage: breakPackage.type_package,
        isShow: true
      }
    })

    this.images = conferenceProject.images
    this.conferenceId = conferenceProject.id
    this.title = conferenceProject.title || hyphenSymbol
    this.detail = conferenceProject.detail || hyphenSymbol
    this.image = conferenceProject.image || ''
    this.timeLength = `${conferenceProject.time.open || hyphenSymbol} - ${conferenceProject.time.close || hyphenSymbol}${textTime}`
    this.limit = `${limitPeople} ${person}`
    this.usable = `${conferenceProject.usable || hyphenSymbol} ตรม.`
    this.address = conferenceProject.address || ''
    this.conferencePrice = formatToMoney(conferenceProject.price) || ''
    this.conferencePricePackagePerUnit = pricePackagePerUnitText

    this.priceOption = conferenceProject.price_options && conferenceProject.price_options.length > 0
      ? conferenceProject.price_options.map((priceOp) => {
        const timeDropdown = timeDurationDropdown.find(
          (time) => time.value === priceOp.time_duration
        )

        const dropdownText = timeDropdown && timeDropdown.label
          ? timeDropdown.label
          : null

        return {
          pattern: priceOp.pattern,
          limitFrom: priceOp.limit.from || null,
          limitTo: priceOp.limit.to || null,
          timeDuration: priceOp.time_duration,
          additionPricePerHour: formatToMoney(
            priceOp.addition_price_per_hour
          ) || '',
          dropdownText,
          price: formatToMoney(priceOp.price) || ''
        }
      })
      : null

    this.breakPackages = breakPackages || null
    this.pricePackPerUnitText = pricePackPerUnitText || null
  }
}
